var map = {
	"./almas/logo.png": 805,
	"./dev/hospital.jpg": 25,
	"./dev/logo.png": 886,
	"./mitera/hospital.jpg": 354,
	"./mitera/logo.png": 593,
	"./success-image.png": 150,
	"./test/hospital.jpg": 18,
	"./test/logo.png": 537,
	"./title-image.png": 281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;